module.exports = __webpack_public_path__ + "static/gradient_small-ff509dbcc83c532953e9bcd24530d537.png";